
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { CreateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { BaseModel, QuoteCollectionModel, QuoteLineModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";


const quotesUrl = "/api/v2/quotes";

export interface CustomCreateQuoteApiParameter 
{
    quoteParameter: CreateQuoteApiParameter
    properties: { [key: string]: string };
}

export async function createQuote(createQuoteParameter: CustomCreateQuoteApiParameter): Promise<ServiceResult<QuoteModel>> {
    try {
        const quote = await post<CustomCreateQuoteApiParameter, QuoteModel>(quotesUrl, createQuoteParameter);
        return {
            successful: true,
            result: quote,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

